import { fa1 } from '@fortawesome/pro-regular-svg-icons/fa1';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text, TextWidgetConfig } from './text/text';
import { WIDGET_TYPE } from './widget-type';
import { FillColorProperty } from '../properties-panel/widget-properties/fill/fill';
import { FontColorProperty } from '../properties-panel/widget-properties/font-color/font-color';
import { FontFamilyProperty } from '../properties-panel/widget-properties/font-family/font-family';
import { FontSizeProperty } from '../properties-panel/widget-properties/font-size/font-size';
import { HeightProperty } from '../properties-panel/widget-properties/height-input/height-input';
import { HorizontalTextAlignmentProperty } from '../properties-panel/widget-properties/horizontal-text-alignment/horizontal-text-alignment';
import { IsBoldProperty } from '../properties-panel/widget-properties/is-bold/is-bold';
import { IsItalicProperty } from '../properties-panel/widget-properties/is-italic/is-italic';
import { VerticalTextAlignmentProperty } from '../properties-panel/widget-properties/vertical-text-alignment/vertical-text-alignment';
import { WidthProperty } from '../properties-panel/widget-properties/width-input/width-input';

import type { PageNumberWidget, PageNumberWidgetDefinition, WidgetConfig, WidgetProperties } from '../config';

const pageNumberDefinition: PageNumberWidgetDefinition = {
  type: WIDGET_TYPE.pageNumber,
  ui: {
    label: 'Page Number',
    pickerElement: <FontAwesomeIcon icon={fa1} />,
  },
  initialConfiguration: {
    ...TextWidgetConfig.definition.initialConfiguration,
    content: 'PageNo()',
  },
};

const pageNumberProperties: WidgetProperties<PageNumberWidget> = [
  WidthProperty,
  HeightProperty,
  FillColorProperty,
  FontFamilyProperty,
  FontColorProperty,
  FontSizeProperty,
  IsBoldProperty,
  IsItalicProperty,
  HorizontalTextAlignmentProperty,
  VerticalTextAlignmentProperty,
];

export const PageNumberWidgetConfig: WidgetConfig<PageNumberWidget> = {
  Component: Text,
  definition: pageNumberDefinition,
  properties: pageNumberProperties,
};
